// extracted by mini-css-extract-plugin
export default {"title":"Favorites_title__tT54b","container":"Favorites_container__dZNlb"};